export const MARKER_START2 = 'MARKER_START2'